import MaxWidth1200Layout from "@/components/Layout/MaxWidth1200Layout";
import { css } from "@emotion/react";
import { getCdnImageSrc, MQ, useResponsive, VStack } from "goi_common";
import React from "react";

export default function MatchHead() {
  const { isBiggerThanMd, setResponsive } = useResponsive();
  return (
    <MaxWidth1200Layout>
      <VStack
        height={setResponsive("288px", "376px", "460px")}
        padding={`0px ${setResponsive("24px", "40px", "40px")}`}
        className="white"
        background={`url(${getCdnImageSrc("platform/home/carousel-4.png")})`}
        backgroundPosition="center"
        backgroundSize="cover"
        justifyContent="center"
        gap={12}
      >
        <div css={matchTitleFontCss}>
          우리가 찾던 장례 전문가,
          <br />
          고이에서.
        </div>
        <div className={isBiggerThanMd ? "head2_sb" : "body3_m"}>
          고이가 까다롭게 선별한 정직한 상조를 {isBiggerThanMd || <br />}추천받아 보세요
        </div>
      </VStack>
    </MaxWidth1200Layout>
  );
}

const matchTitleFontCss = css({
  fontSize: "24px",
  fontWeight: 600,
  lineHeight: "32px",
  letterSpacing: "0px",

  [MQ.md]: {
    fontSize: "42px",
    fontWeight: 700,
    lineHeight: "60px",
    letterSpacing: "-0.4px",
  },
});
